import React from 'react';

import { Household } from './AddGuestRail';
import styles from './householdRow.scss';
import { findLeader } from '../../helpers/households';

interface Props {
  household: Household;
}

const HouseholdNameRow: React.FC<Props> = ({ household }) => {
  const leader = findLeader(household)!;
  const householdSize = household ? household.people.length : 0;

  return (
    <div className={styles.householdRow}>
      <div className={styles.householdInfo}>
        <div className={styles.leaderName}>
          <span>
            {leader!.firstName} {leader!.lastName}
          </span>
          <span>{householdSize > 1 ? ` + ${householdSize - 1} guest${householdSize > 2 ? 's' : ''}` : ''}</span>
        </div>
      </div>
    </div>
  );
};

export default HouseholdNameRow;
